import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-tln-info',
  templateUrl: './tln-info.component.html',
  styleUrls: ['./tln-info.component.css']
})
export class TlnInfoComponent {


}
